import { RecurringPaymentStatus } from '../../../../../../../../../../shared/types/GlobalRecurringPaymentsStatus'
import { type RecurringPayment } from '../../../../../../../../../../shared/proxies/recurringPaymentProxy'
import { RpOccurrenceStatusEnum } from '../../../../../../../../../../shared/types/GlobalRPOccurrenceStatuses'
import { type RpOccurrence } from '../../../../../../../[id]/rp-occurrence/rpOccurrenceProxy'
import { usdFormatter } from '../../../../../../../../../../shared/utils/formattingUtils'
import { GlobalTransactionStatus } from '../../../../../../../../../../shared/types/GlobalTransactionStatus'

export function calculateAmountCentsSum (rpOccurrence: RpOccurrence): number {
  if (!rpOccurrence.transactions || rpOccurrence.transactions.length === 0) {
    return 0
  }

  // For multiple transactions, only count the successful ones...BC
  const totalAmount = rpOccurrence.transactions.reduce((accumulator, transaction) => {
    if (transaction.status === GlobalTransactionStatus.Complete) {
      return accumulator + transaction.amountCents
    }
    return accumulator
  }, 0)

  return totalAmount
}
export function calculateRemainingAmountCentsSum (rpOccurrence: RpOccurrence): number {
  if (!rpOccurrence.transactions || rpOccurrence.transactions.length === 0) {
    return 0
  }

  const totalAmount = rpOccurrence.transactions.reduce((accumulator, transaction) => {
    if (transaction.status === GlobalTransactionStatus.Complete) {
      return accumulator + transaction.remainingAmountCents
    }
    return accumulator
  }, 0)

  return totalAmount
}
export function formattedTotalValue (rpOccurrence: RpOccurrence): string {
  return usdFormatter.format(calculateRemainingAmountCentsSum(rpOccurrence))
}

interface Args {
  remainingAmountCents: number
  amountCentsSum: number
}
export function formattedRefundText ({ remainingAmountCents, amountCentsSum }: Args): string {
  // Return an empty string because it means the transaction failed and no retries...BC
  if (amountCentsSum === 0) { return ('') }

  if (remainingAmountCents === 0) { return ('Fully Refunded') }
  if (remainingAmountCents < amountCentsSum) { return ('Partially Refunded') }
  return ''
}

export function determineTextColorClass (recurringPayment: RecurringPayment): string | null {
  if (recurringPayment.status === RecurringPaymentStatus.Paused) {
    return 'text-wpy-orange-yellow-700'
  } else if (recurringPayment.status === RecurringPaymentStatus.Errored) {
    return 'text-gray-400'
  } else {
    return null
  }
}

export function determineStatusColorClass (recurringPayment: RecurringPayment | null | undefined): string | null {
  if (!recurringPayment) { return null }

  switch (recurringPayment.status) {
    case RecurringPaymentStatus.Active:
      return 'border-green-700 bg-green-100 text-green-700'
    case RecurringPaymentStatus.Paused:
    case RecurringPaymentStatus.Ended:
      return 'border-gray-600 bg-gray-100 text-gray-600'
    case RecurringPaymentStatus.Errored:
      return 'border-wpy-alert-red-600 bg-wpy-alert-red-100 text-wpy-alert-red-600'
    default:
      return null
  }
}

export function determineTextColorClassRpOccurrence (rpOccurrence: RpOccurrence): string | null {
  switch (rpOccurrence.status) {
    case RpOccurrenceStatusEnum.SUCCESS:
      return 'border-green-700 bg-green-100 text-green-700'
    case RpOccurrenceStatusEnum.FAILED_UNRESOLVED:
      return 'border-wpy-alert-red-600 bg-wpy-alert-red-100 text-wpy-alert-red-600'
    case RpOccurrenceStatusEnum.PENDING:
      return 'border-wpy-blue-500 bg-wpy-blue-100 text-wpy-blue-500'
    case RpOccurrenceStatusEnum.SKIPPED:
    case RpOccurrenceStatusEnum.FAILED_RESOLVED:
      return 'border-gray-600 bg-gray-100 text-gray-600'
    case RpOccurrenceStatusEnum.REFUNDED_FULL:
    case RpOccurrenceStatusEnum.REFUNDED_PARTIAL:
      return 'border-wpy-orange-yellow-700 bg-wpy-orange-yellow-100 text-wpy-orange-yellow-700'
    default:
      return null
  }
}
